export default __webpack_public_path__ + "static/media/Canadian-Cheque.03059e34.jpg";